import { differenceInCalendarDays, isValid, parse } from "date-fns";

/** 0 — сегодня, 1 — вчера; начиная с позавчера WORKER только смотрит. */
export const WORKER_EDIT_LOCK_DAYS = 2;

/** Подсказка на заблокированных кнопках. */
export const EDIT_LOCKED_TITLE = "לא ניתן לערוך תאריך עבר";

/**
 * Блокирует редактирование для WORKER на прошедших датах (по календарным дням,
 * локальное время). Будущие и невалидные даты не блокируются.
 */
export const isDateLockedForWorker = (
  date: string,
  today: Date,
  isWorker: boolean
): boolean => {
  if (!isWorker) return false;
  const selected = parse(date, "yyyyMMdd", today);
  if (!isValid(selected)) return false;
  return differenceInCalendarDays(today, selected) >= WORKER_EDIT_LOCK_DAYS;
};
